import { EMPTY_SYMBOL } from '../../constants/string-constants';

export const formatDateYearMonthDay = (dateTime: Date | null | number | string | undefined) => {
  if (dateTime) {
    const date = new Date(dateTime);
    const utcDate = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());

    return new Date(utcDate).toISOString().split('T')[0];
  }

  return EMPTY_SYMBOL;
};

export const formatDateLong = (
  dateTime: Date | null | number | string | undefined,
  locale: string
) => {
  if (dateTime) {
    const date = new Date(dateTime);

    return date.toLocaleDateString(locale || 'en-US', {
      day: '2-digit',
      month: 'long',
      year: 'numeric',
    });
  }

  return EMPTY_SYMBOL;
};
